import React, { useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import Api from "services/api";
import { ListLayout } from "components/common/ListLayout";
import TableHeaderItem from "components/common/ListLayout/TableHeaderItem";
import { usePermissions } from "layouts/Admin";
import { invoicesSelector } from "slices/invoiceSlice";
import { fetchGeneratedInvoices } from "slices/invoiceSlice";
import { Link } from "react-router-dom";
import { cdn } from "constants/common";
import { userSelector } from "slices/userSlice";
import toast from "react-hot-toast";
import ConfirmationModal from "components/common/ConfirmationMessage";
import { removeMultipleInvoices } from "slices/invoiceSlice";
import { changeStatus } from "slices/invoiceSlice";
import ConfirmationStatus from "components/common/ConfirmationMessageStatus";

const apiService = new Api();

function InvocieList() {
  const dispatch = useDispatch();
  const { checkPermission } = usePermissions();
  const { user } = useSelector(userSelector);
  const userToken = user.token;
  const {
    generatedInvoices,
    last_page: totalPages,
    loader,
    total,
    current_page,
    per_page: pageLength,
  } = useSelector(invoicesSelector);

  const [addForm, setAddForm] = React.useState({
    show: false,
    item: {},
  });
  const refAddutton = React.useRef(null);

  const [selectedItems, setSelectedItems] = React.useState([]);
  const [selectAll, setSelectAll] = React.useState(false);
  const [deleteModal, setDeleteModal] = React.useState(false);
  const [statusModal, setStatusModal] = React.useState(false);
  const [itemId, setItemId] = React.useState();
  const [currentPage, setCurrentPage] = React.useState(1);
  const [searchTerm, setSearchTerm] = React.useState("");
  const [sortConfig, setSortConfig] = React.useState({
    sortBy: "name",
    sortDirection: "asc",
  });

  React.useEffect(() => {
    dispatch(fetchGeneratedInvoices());
  }, []);

  const submitCallback = (status, message) => {
    if (status) {
      toast.success(message, {
        className: "successToast",
      });
      setSelectedItems([]);
      setSelectAll(false);
      dispatch(fetchGeneratedInvoices());
      hideConfirmDialog();
    } else {
      toast.error(message, {
        className: "errorToast",
      });
    }
  };

  const showConfirmDialog = () => {
    setDeleteModal(true);
    return;
  };
  const hideConfirmDialog = () => {
    setDeleteModal(false);
  };
  const handleRemoveItems = () => {
    dispatch(removeMultipleInvoices({ ids: selectedItems }, submitCallback));
  };
  const handleChange = (e) => {
    // handle form change
    const id = e.target.dataset.value;
    setSelectedItems(
      selectedItems.includes(id)
        ? selectedItems.filter((item) => item != id)
        : [...selectedItems, id]
    );
  };
  const handleToggleSelectAll = () => {
    if (selectAll) {
      setSelectedItems([]);
      setSelectAll(false);
      return;
    }
    setSelectAll(true);
    setSelectedItems(generatedInvoices?.map((item) => item.id.toString()));
  };

  const hideConfirmStatusDialog = () => {
    setStatusModal(false);
  };
  const showConfirmStatusDialog = (id) => {
    setStatusModal(true);
    setItemId(id);
  };
  const handleStatusPaid = (id) => {
    setStatusModal(!statusModal);
    dispatch(changeStatus(id, submitCallback));
  };

  //#region TABLE HEAD

  const renderTableHeader = React.useCallback(() => {
    const callBack = (dir, sortBy) => {
      setSortConfig({ sortBy, sortDirection: dir });
      dispatch(
        fetchGeneratedInvoices(currentPage, {
          sortBy: sortBy,
          sortDirection: dir,
          search: searchTerm,
        })
      );
    };
    return (
      <tr>
        <th>
          <div className="row_check">
            <span>#</span>
            {checkPermission("Delete Invoices") && (
              <label className="custom-checkbox checkbox">
                <input
                  type="checkbox"
                  name="select-all"
                  checked={selectAll}
                  onChange={handleToggleSelectAll}
                />
                <span className="checkmark"></span>
              </label>
            )}
          </div>
        </th>
        <th>
          <TableHeaderItem
            title="Client Name"
            sortBy="name"
            sortDirection={sortConfig.sortDirection}
            callBack={callBack}
          />
        </th>

        <th>
          <TableHeaderItem
            title="Invoice Number"
            sortBy="invoice_number"
            sortDirection={sortConfig.sortDirection}
            callBack={callBack}
          />
        </th>
        <th>
          <TableHeaderItem
            title="Total Appointments"
            sortBy="total_appointments"
            sortDirection={sortConfig.sortDirection}
            callBack={callBack}
          />
        </th>
        <th>
          <TableHeaderItem
            title="Billing Date"
            sortBy="billing_date"
            sortDirection={sortConfig.sortDirection}
            callBack={callBack}
          />
        </th>
        <th>
          <TableHeaderItem
            title="Total due bill"
            sortBy="total_due_bill"
            sortDirection={sortConfig.sortDirection}
            callBack={callBack}
          />
        </th>
        <th>Status</th>
        {(checkPermission("Change Status") ||
          checkPermission("Download Invoices")) && (
          <th className="col-2">Actions</th>
        )}
      </tr>
    );
  }, [selectAll, searchTerm, sortConfig, currentPage, selectedItems]);

  //#endregion

  //#region TABLE BODY

  const renderTableContent = React.useCallback(() => {
    return generatedInvoices?.map((item, index) => (
      <InvoicesItems
        userToken={userToken}
        data={item}
        index={index}
        selectedItems={selectedItems}
        handleChange={handleChange}
        current_page={current_page}
        pageLength={pageLength}
        checkPermission={checkPermission}
        showConfirmStatusDialog={showConfirmStatusDialog}
      />
    ));
  }, [generatedInvoices, selectedItems]);

  //#endregion

  return (
    <ListLayout
      heading="Generated Invoices"
      searchPlaceholder="Search Invoices"
      time={false}
      addButtonDisabled={true}
      renderTableHeader={renderTableHeader}
      renderTableContent={renderTableContent}
      totalPages={totalPages}
      fetchList={fetchGeneratedInvoices}
      selectedItems={selectedItems}
      handleRemoveItems={handleRemoveItems}
      refAddutton={refAddutton}
      addForm={addForm}
      showConfirmDialog={showConfirmDialog}
      searchTerm={searchTerm}
      setSearchTerm={setSearchTerm}
      loader={loader}
      noOfItems={total}
    >
      {deleteModal && (
        <ConfirmationModal
          onClose={hideConfirmDialog}
          isOpen={deleteModal}
          onConfirm={handleRemoveItems}
        />
      )}
      {statusModal && (
        <ConfirmationStatus
          onClose={hideConfirmStatusDialog}
          isOpen={statusModal}
          onConfirm={() => handleStatusPaid(itemId)}
        />
      )}
    </ListLayout>
  );
}

const InvoicesItems = ({
  data,
  index,
  current_page,
  pageLength,
  checkPermission,
  selectedItems,
  handleChange,
  showConfirmStatusDialog,
}) => {
  const serial = useMemo(() => {
    return index + 1 + (current_page - 1) * pageLength;
  }, [current_page, pageLength]);

  return (
    <tr>
      <td>
        <div className="row_check">
          <span>{serial}</span>
          {checkPermission("Delete Invoices") && (
            <label className="custom-checkbox checkbox">
              <input
                type="checkbox"
                name="select-all"
                data-value={data.id}
                checked={selectedItems.includes(data.id.toString())}
                onChange={handleChange}
              />
              <span className="checkmark"></span>
            </label>
          )}
        </div>
      </td>
      <td>{data?.client?.user?.name}</td>
      <td>{data?.invoice_number}</td>
      <td>{data?.total_appointments}</td>
      <td>{data?.billing_date}</td>
      <td>{`$${data?.total_due_bill}`}</td>
      <td>{data?.status}</td>
      {(checkPermission("Change Status") ||
        checkPermission("Download Invoices")) && (
        <td>
          <div className="d-flex align-content-center gap-2">
            {checkPermission("Change Status") && data?.status !== "Paid" && (
              <button
                onClick={() => showConfirmStatusDialog(data?.id)}
                className="main_button yellow me-2"
              >
                Paid
              </button>
            )}
            {checkPermission("Download Invoices") && (
              <Link
                to={`/invoices/pdf-view/${data?.id}`}
                className="table_delete text-nowrap"
              >
                Download invoice
              </Link>
            )}
          </div>
        </td>
      )}
    </tr>
  );
};

export default InvocieList;
